import routes from '@@/core/routes'

export default routes;
